<script>
import { createNamespacedHelpers } from 'vuex'
import isEmptyObject from '~/helpers/is-empty-object'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'sc-render',
  props: ['fields', 'emptyMessage'],
  computed: {
    ...mapJssGetters([
      'isEditMode'
    ]),
    message () {
      return this.emptyMessage || this.$t('SC_RENDER')
    },
    hasData () {
      return !!this.$slots.default && !!this.$slots.default.length && !isEmptyObject(this.fields)
    }
  },
  render (createElement) {
    if (this.hasData) {
      return this.$slots.default[0]
    }
    if (this.isEditMode && !this.hasData) {
      return createElement('h1', { attrs: { class: 'empty-message' } },
        this.message)
    }
    return null
  }
}
</script>


<style lang="scss" scoped>

.empty-message {
  @include font('090');

  text-align: center;
  color: $color-slate-dark;
  padding: $space-060;
  font-weight: 600;
}
</style>
